import { createFileRoute, redirect } from "@tanstack/react-router";

// /$locale/sobre aponta para a página institucional /sobre — redirecionamento permanente (301).
export const Route = createFileRoute("/$locale/sobre")({
  beforeLoad: () => {
    throw redirect({ to: "/sobre", statusCode: 301 });
  },
});
